import { createContext } from 'react';

import { NavigationContextValue } from './navigation.type';

/**
 * The context object only. The provider lives in `navigation-provider.tsx`, and this module
 * imports react and its own siblings — nothing else, or the hooks layer inherits the
 * provider's render tree again (B2B-2167).
 */
export const NavigationContext = createContext<NavigationContextValue>({
  navigationItems: [],
  isItemClicked: false,
  setNavigation: () => {},
  setIsItemClicked: () => {},
  preventRedirect: false,
  setPreventRedirect: () => {},
  redirectUrl: '',
  setRedirectUrl: () => {},
  route: {
    from: '',
    to: '',
  },
});
